import React, { useState, useCallback, memo } from 'react';
import { useDrop } from 'react-dnd';
export const TargetContainer = memo(function TargetContainer({ onDrop, lastDroppedColor, children, type}) {
    const [{ isOver }, drop] = useDrop(() => ({
        accept: type,
        drop(_item, monitor) {
            // transfer reference of dragged item into drop area
            onDrop(_item[0], _item[1]);
            return undefined;
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        }),
    }), [onDrop]);
    const opacity = isOver ? 0.7 : 1;
    return (<div ref={drop} data-color={lastDroppedColor || 'none'} style={{ opacity, backgroundColor: isOver ? '#ddd' : '#fff' }} data-testid={`target-${type}`}>
			{children}
		</div>);
});
export const StatefulTargetBox = (props) => {
    const [lastDroppedColor, setLastDroppedColor] = useState(null);
    const handleDrop = useCallback((color) => setLastDroppedColor(color), []);
    return (<TargetContainer {...props} lastDroppedColor={lastDroppedColor} onDrop={handleDrop}/>);
};